import { DocumentsTypesEnum, IAttachmentInExpenditure } from "redux/modules/common/passportsAndCertificates/types";

export const getAttachmentName = (doc: IAttachmentInExpenditure) => {
  if (doc.type === DocumentsTypesEnum.file) return doc.originalname;
  return doc.type_display;
};

export const filterAttachmentsByType = (doc: IAttachmentInExpenditure) => doc.type !== DocumentsTypesEnum.file;
